<template>
  <table-ag :row-data='data' :column-defs='columns' :components='components' :pagination='true' :search='false'></table-ag>
</template>
<script>
import tableAg from '../../dashboard/tableAg.vue'
import graphBar from './graphBar.vue'
export default {
  data(){
    return {
      columns: [
        {
          field: 'label',
          headerName:'Nombre',
          editable: false
        },
        {
          field: 'data',
          headerName:'Personas',
          cellRenderer: 'GraphBar',
          editable: false,
          sort: 'desc'
        },
      ],
      components: {
        GraphBar: () => {
          return {
            render: h => h(graphBar,{
              props:{
                allData: this.data
              },
            })
          }
        }
      },
    }
  },
  props:{
    data: Array
  },
  methods:{
    sortData(data, object = false){
      if(data){
        if(object){
          data = data.filter((e) => {
            if(e.SubGrupo){
              return true;
            }
            return false;
          })
          return data.slice().sort(function(a, b) {
            let numA, numB;

            numA = parseFloat(a['countData']['sum'])
            numB = parseFloat(b['countData']['sum'])

            return numB - numA; // Orden descendente
          })
        }
        if (data.every((item) => !isNaN(item['countData']['sum']))){
          return data.slice().sort((a, b) => b - a)
        }
        return data.slice().sort()
      }
      return data
    },
  },
  components:{
    tableAg
  },
}
</script>
<style lang='scss'>

</style>



// WEBPACK FOOTER //
// src/components/frpm/components/tableDemo.vue